import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const Card = styled(Link)`
    &:hover {
        img {
            transition: 0.6s all ease;
            transform: scale(1.2);
        }
    }
    .row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 14px;
        margin-bottom: 3px;

        .circle {
            width: 16px;
            height: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            background: #000;

            &_small {
                width: 4px;
                height: 4px;
                border-radius: 50%;
            }

            &.green {
                background: #ebf6ec;
            }

            &.orange {
                background: #faf1ee;
            }

            &.purple {
                background: #f2f0ff;
            }

            &_small.green {
                background: #19a33c;
            }

            &_small.orange {
                background: #c5684b;
            }

            &_small.purple {
                background: #7b61ff;
            }
        }
    }

    h3 {
		font-weight: 300;
		font-size: 14px;
		color: #1b1b1b;
		max-width: 250px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	p {
		font-size: 14px;
		color: #1b1b1b;
		font-weight: 500;
	}
    @media screen and (max-width: 768px) { 
        h3 { 
            font-size: 16px!important;
            max-width: 300px;
        }
        p { 
            font-size: 16px!important;
        }
    }
`

const Image = styled.div`
    width: 294px;
    height: 294px;
    overflow: hidden;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
        min-height: 100%;
        min-width: 100%;
        width: 100%;
    }
    @media screen and (max-width: 768px) { 
        width: 300px!important;
        height: 300px!important;
    }
`

const Item = ({ i }) => {
    const makeNameShort = (str) => {
        if (typeof str == 'string') {
            return str.length > 35 ? str.substr(0, 35) + ' ...' : str
        }
    }

    return (
        <Card to={`/item/${i.id}`} key={i.id}>
            <Image>
                <img src={i.images[0]} alt="" />
            </Image>
            <div className="row">
                <h3>{makeNameShort(i.title)}</h3>
                <div className="circle green">
                    <div className="circle_small green"></div>
                </div>
            </div>
            <p>{i.cost}₸</p>
        </Card>
    )
}

// {i?.seller?.name}

export default Item
